import {
    PURCHASE_SALE_ORDER_BALANCE_REPORT_REQUEST,
    PURCHASE_SALE_ORDER_BALANCE_REPORT_SUCCESS,
    PURCHASE_SALE_ORDER_BALANCE_REPORT_FAILURE,
  } from "../types/purchase-sale-order-balance-report-types.js";
  
  const initialState = {
    purchaseSaleOrderBalanceReport: {},
    loading: false,
    error: null,
  };
  
  const purchaseSaleOrderBalanceReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_SALE_ORDER_BALANCE_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case PURCHASE_SALE_ORDER_BALANCE_REPORT_SUCCESS: {
        return {
          ...state,
          purchaseSaleOrderBalanceReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PURCHASE_SALE_ORDER_BALANCE_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default purchaseSaleOrderBalanceReportReducer;
  